<script setup lang="ts">
import type { JSONContent } from '@tiptap/vue-3';

import { useRichTextEditorRender } from './useRichTextEditorRenderer';

interface Props {
  content: JSONContent;
}

const props = defineProps<Props>();

const { rootDocItems, renderText } = useRichTextEditorRender(computed(() => props.content));

const getText = (paragraph: JSONContent) => paragraph.content?.filter(c => c.type === 'text') || [];
</script>

<template>
  <!-- start heading content container -->
  <template v-for="(paragraph, index) in rootDocItems" :key="index">
    <!-- if empty (black line), translates into break -->
    <br v-if="!paragraph.content">
    <template v-for="(_content, pIndex) in getText(paragraph)" :key="pIndex">
      <template v-if="!_content.marks && !_content.attrs">
        {{ _content.text }}
      </template>
      <component :is="renderText(_content)" v-else />
    </template>
  </template>
  <!-- end heading content container -->
</template>
